
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export default function BizNetTypeBasicInfoComponent({ networks, selectedBiznetType, handleInnerFormChange }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
             <InputContainer
            isDisabled
              label="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                );
              }}
              type="text"
              value={selectedBiznetType?.Name}
            />
            <InputContainer
            isDisabled
              label="DBaaS Network Name"
              labelField="Name"
              list={networks}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DBaaSNetworkId',

                );
              }}
              type="select"
              value={selectedBiznetType?.DBaaSNetworkId}
              valueField="Id"
            />
               <InputContainer
            isDisabled
              label="DBNIE AccountType Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'IEAccountTypeName',

                );
              }}
              type="text"
              value={selectedBiznetType?.IEAccountTypeName}
            />
          </div>

        }
        expandedPanel="basicInfo"
        headerTitle="Basic Information"
      />

    </>
  )
}